import { Component, OnInit, ChangeDetectionStrategy } from '@angular/core';
import { PointageJournalier } from 'src/app/domain/RH/pointage-journalier';
import { PointagePause } from 'src/app/domain/RH/pointage-pause';
import { PointageService } from 'src/app/services/pointage.service';
import { NotificationManager } from 'src/app/tools/ui/notification-manager';
import { PointageBoxDialog } from 'src/app/tools/ui/pointage-box/pointage-box';
import * as _ from 'lodash'
import { Temporal } from '@js-temporal/polyfill';
import { CoreData } from 'src/app/tools/core-data/core-data';
import { MatSnackBar } from '@angular/material/snack-bar';
import { MatDialog } from '@angular/material/dialog';

@Component({
    selector: 'app-pointage',
    templateUrl: './pointage.component.html',
    styleUrls: ['./pointage.component.scss'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class PointageComponent implements OnInit {
    public Model: PointageJournalier = new PointageJournalier();

    DefaultTime!: string;
    DepartDomicile: Date | null = null;
    ArriveeDomicile: Date | null = null;
    DebutJournee: Date | null = new Date();
    FinJournee: Date | null = new Date();

    constructor(
        private coreData: CoreData,
        private snackBar: MatSnackBar,
        private dialog: MatDialog,
        private pointageService: PointageService
    ) { }

    ngOnInit(): void {

        this.coreData.CurrentPageName = "Pointage";

        this.Model.DebutJournee = Temporal.Now.plainDateTimeISO();
        this.Model.FinJournee = Temporal.Now.plainDateTimeISO();

        this.pointageService.getPointage().subscribe(x => {
            if (x) {
                this.Model = x;
                this.ArriveeDomicile = this.Model.ArriveeDomicile ? this.toDate(this.Model.ArriveeDomicile) : null;
                this.DebutJournee = this.Model.DebutJournee ? this.toDate(this.Model.DebutJournee) : null;
                this.DepartDomicile = this.Model.DepartDomicile ? this.toDate(this.Model.DepartDomicile) : null;
                this.FinJournee = this.Model.FinJournee ? this.toDate(this.Model.FinJournee) : null;
            }
        });
    }

    clearDepartDomicile() {
        this.DepartDomicile = null;
        this.Model.DepartDomicile = undefined;
    }

    clearArriveeDomicile() {
        this.ArriveeDomicile = null;
        this.Model.ArriveeDomicile = undefined;
    }

    timeSetDepartDomicile(event: string) {
        const value = this.withTime(this.DepartDomicile, event);
        this.DepartDomicile = value;
        this.Model.DepartDomicile = this.toPlainDateTime(value);
    }

    timeSetArriveeDomicile(event: string) {
        const value = this.withTime(this.ArriveeDomicile, event);
        this.ArriveeDomicile = value;
        this.Model.ArriveeDomicile = this.toPlainDateTime(value);
    }

    timeSetDebutJournee(event: string) {
        const value = this.withTime(this.DebutJournee, event);
        this.DebutJournee = value;
        this.Model.DebutJournee = this.toPlainDateTime(value);
    }

    timeSetFinJournee(event: string) {
        const value = this.withTime(this.FinJournee, event);
        this.FinJournee = value;
        this.Model.FinJournee = this.toPlainDateTime(value);
    }

    formatTime(value: Date | null): string {
        return value ? `${String(value.getHours()).padStart(2, '0')}:${String(value.getMinutes()).padStart(2, '0')}` : '';
    }

    private withTime(value: Date | null, time: string): Date {
        const [hours, minutes] = time.split(':').map(Number);
        const date = new Date(value ?? new Date());
        date.setHours(hours, minutes, 0, 0);
        return date;
    }

    private toDate(value: Temporal.PlainDateTime): Date {
        return new Date(value.year, value.month - 1, value.day, value.hour, value.minute);
    }

    private toPlainDateTime(value: Date): Temporal.PlainDateTime {
        return Temporal.PlainDateTime.from({ year: value.getFullYear(), month: value.getMonth() + 1, day: value.getDate(), hour: value.getHours(), minute: value.getMinutes() });
    }

    openPauseDialog() {

        const dialogRef = this.dialog.open(PointageBoxDialog, {
            data: {},
            width: '777px',
            disableClose: true
        });

        dialogRef.afterClosed().subscribe(result => {
            if (result) {
                this.Model.PointagePauseList.push(result);
                NotificationManager.handleSuccess('Pause ajoutée', this.snackBar);
            }
        });
    }

    deletePause(p: PointagePause) {
        _.remove(this.Model?.PointagePauseList!, p);
        NotificationManager.handleSuccess('Pause suprimée', this.snackBar);
    }

    save() {
        this.pointageService.putPointage(this.Model).subscribe(x => {
            NotificationManager.handleSuccess('Pointage enregistré', this.snackBar);
        });
    }
}
